import { useSearchParams } from "react-router-dom";

/**
 * 下載桌布檢視頁（外開網頁）。
 *
 * 分享文字裡的「下載桌布」連結指向這裡：/wallpaper/view?img=<合成圖URL>。
 * 收到分享的人點開後，看到的是我們排好版的頁面（白底、圖置中、留白），
 * 而不是瀏覽器內建的原始圖片檢視器（會被縮放到滿版）。
 * 長按圖片即可儲存到相簿。
 */
export default function WallpaperViewPage() {
	const [params] = useSearchParams();
	const img = params.get("img");
	// 只接受 https 圖片網址，避免被塞入奇怪的連結
	const safeImg = img && /^https:\/\//i.test(img) ? img : null;

	return (
		<div
			style={{
				minHeight: "100svh",
				width: "100%",
				boxSizing: "border-box",
				background: "#fff",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: "12vw 6vw",
			}}
		>
			{safeImg && (
				<img
					src={safeImg}
					alt="Tory Burch Wallpaper"
					style={{
						maxWidth: "66%",
						maxHeight: "80svh",
						height: "auto",
						objectFit: "contain",
						display: "block",
					}}
				/>
			)}
		</div>
	);
}
